/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'nyJHN3xMvoDPa78aFWhXYz.png': { uri: '/images/nyJHN3xMvoDPa78aFWhXYz.png' },
'sXHNvzVHqSQUE7ktxhBLct.png': { uri: '/images/sXHNvzVHqSQUE7ktxhBLct.png' },
'oskd1gzTMCiUnUrH3YhyXG.png': { uri: '/images/oskd1gzTMCiUnUrH3YhyXG.png' },
'kdau245J2jbV7Lr9WNL7RN.png': { uri: '/images/kdau245J2jbV7Lr9WNL7RN.png' },
'eHBisFKJWbN7noAUTqFoN8.png': { uri: '/images/eHBisFKJWbN7noAUTqFoN8.png' },
'8gbqV8Uz7qX4N3QxojNVHh.png': { uri: '/images/8gbqV8Uz7qX4N3QxojNVHh.png' },
'gyWX9PNnNvmSmfV7Y6QxVZ.png': { uri: '/images/gyWX9PNnNvmSmfV7Y6QxVZ.png' },
'nfBLp2rs3Pu21JaH5CvWhS.png': { uri: '/images/nfBLp2rs3Pu21JaH5CvWhS.png' },
'id3GGnrXJ5RUS2eHDMvJN9.png': { uri: '/images/id3GGnrXJ5RUS2eHDMvJN9.png' },
'w8Q94YP6uQkpWMmPAUjLj7.jpg': { uri: '/images/w8Q94YP6uQkpWMmPAUjLj7.jpg' },
'hXPioW3CYf1v6UsHhNB5dH.png': { uri: '/images/hXPioW3CYf1v6UsHhNB5dH.png' },
'cgb89USiFGnD7k5Z7QSFxv.jpg': { uri: '/images/cgb89USiFGnD7k5Z7QSFxv.jpg' },
'buNtBFXC7famAEdd9qJEZA.png': { uri: '/images/buNtBFXC7famAEdd9qJEZA.png' },
'f7MhTeR5QUZ2WiJ3MX5WtQ.png': { uri: '/images/f7MhTeR5QUZ2WiJ3MX5WtQ.png' },
'fxwLauitHLC7GDnRigND3q.png': { uri: '/images/fxwLauitHLC7GDnRigND3q.png' },
'3bUZXVXCECmPXyCxqDLNxg.jpg': { uri: '/images/3bUZXVXCECmPXyCxqDLNxg.jpg' },
'wP7KP2gKAyxTuBr6bXJzfa.png': { uri: '/images/wP7KP2gKAyxTuBr6bXJzfa.png' },
'2fekvifsGCyhfVujoKSHMB.jpg': { uri: '/images/2fekvifsGCyhfVujoKSHMB.jpg' },
'eWcRPwHf5xvTv9zaKuMcsT.png': { uri: '/images/eWcRPwHf5xvTv9zaKuMcsT.png' },
'bbxVPmv1TZJobnX2Se6Af6.jpg': { uri: '/images/bbxVPmv1TZJobnX2Se6Af6.jpg' },
'juyTA5s1psJseCdBpPeHca.png': { uri: '/images/juyTA5s1psJseCdBpPeHca.png' },
'ovCfexu9voo13DQyp7x85G.png': { uri: '/images/ovCfexu9voo13DQyp7x85G.png' },
'2wvDc3o58jrSoLFay4wTMw.png': { uri: '/images/2wvDc3o58jrSoLFay4wTMw.png' },
'aLwEZiFa57CkusFe9QvFrx.jpg': { uri: '/images/aLwEZiFa57CkusFe9QvFrx.jpg' },
'8MGX51LwDjsvFPxZ8bQUo5.png': { uri: '/images/8MGX51LwDjsvFPxZ8bQUo5.png' },
'vdmeYPHFD59ZiBqHnkraXH.png': { uri: '/images/vdmeYPHFD59ZiBqHnkraXH.png' },
'ovzngCFmFWMWab3x3PZbSa.png': { uri: '/images/ovzngCFmFWMWab3x3PZbSa.png' },
'rUGrEG3Ffr1poZgaVzey19.png': { uri: '/images/rUGrEG3Ffr1poZgaVzey19.png' },
'dd5fkFeRxM9zbrVNKbytpw.png': { uri: '/images/dd5fkFeRxM9zbrVNKbytpw.png' },
'obr3FLWXtKWN9YgTYR7329.jpg': { uri: '/images/obr3FLWXtKWN9YgTYR7329.jpg' },
'vkf9D1bd2ykii6mrXEiFZb.png': { uri: '/images/vkf9D1bd2ykii6mrXEiFZb.png' },
'rbTarnaKpPixXPGLaTaurc.png': { uri: '/images/rbTarnaKpPixXPGLaTaurc.png' },
'kLrEpuPqwKRuNcEbJfRwPi.png': { uri: '/images/kLrEpuPqwKRuNcEbJfRwPi.png' },
'p4m4q7Wj4sTz33vSDps73K.png': { uri: '/images/p4m4q7Wj4sTz33vSDps73K.png' },
'tqZXSm3RgzepWaUJTqZ3Nv.png': { uri: '/images/tqZXSm3RgzepWaUJTqZ3Nv.png' },
'mWZC2Svp3MmHCHzmpcSbYU.png': { uri: '/images/mWZC2Svp3MmHCHzmpcSbYU.png' },
'fKz3ZmaUA4adun7w3iqwUU.png': { uri: '/images/fKz3ZmaUA4adun7w3iqwUU.png' },
'fFvnKsUHJVzh91gDgu8THZ.png': { uri: '/images/fFvnKsUHJVzh91gDgu8THZ.png' },
'e9CKSMGkUadFe4q8NwpF18.png': { uri: '/images/e9CKSMGkUadFe4q8NwpF18.png' },
'cceoTUuoeHDSw21ajKVdAq.jpg': { uri: '/images/cceoTUuoeHDSw21ajKVdAq.jpg' },
'eAg773BYecHrjY5P5dW7zv.png': { uri: '/images/eAg773BYecHrjY5P5dW7zv.png' },
'1WoAHwkLK5Rw9TDzE4iWo2.png': { uri: '/images/1WoAHwkLK5Rw9TDzE4iWo2.png' },
'cEKkdSBThpVGAD3NRggMuf.png': { uri: '/images/cEKkdSBThpVGAD3NRggMuf.png' },
'irjz8mUMzofotzXEQVhiuC.png': { uri: '/images/irjz8mUMzofotzXEQVhiuC.png' },
'6WpWikmeMrjDfEti4M2GVB.png': { uri: '/images/6WpWikmeMrjDfEti4M2GVB.png' },
'7SZ2uLDYRwPDHJjC6U4Kfw.png': { uri: '/images/7SZ2uLDYRwPDHJjC6U4Kfw.png' },
'8SRwHZniJyej2gRfFoBgPj.png': { uri: '/images/8SRwHZniJyej2gRfFoBgPj.png' },
'e4E9jbLvHyPbdb8qoYDVEJ.png': { uri: '/images/e4E9jbLvHyPbdb8qoYDVEJ.png' },
'c6xX2DxFGJviixK8ijVdvz.png': { uri: '/images/c6xX2DxFGJviixK8ijVdvz.png' },
'1AXxKneWJ3GwpoSFciZNdP.png': { uri: '/images/1AXxKneWJ3GwpoSFciZNdP.png' },
'3sjdgXqyAeVZygVTgca8WY.png': { uri: '/images/3sjdgXqyAeVZygVTgca8WY.png' },
'vmJ33fHajMBVJ539AbPbZC.png': { uri: '/images/vmJ33fHajMBVJ539AbPbZC.png' },
'iR6dEb6pt3YC18S16iiD9V.png': { uri: '/images/iR6dEb6pt3YC18S16iiD9V.png' },
'uq24bSdgebHtjo8UeFBeST.png': { uri: '/images/uq24bSdgebHtjo8UeFBeST.png' },
'dMaHM9uM2YibTQLqcceqEE.jpg': { uri: '/images/dMaHM9uM2YibTQLqcceqEE.jpg' },
'u6zdkgGmjuoZNAB3PiNCEr.png': { uri: '/images/u6zdkgGmjuoZNAB3PiNCEr.png' },
'x5c42W9QotvTNKmJyXjzkU.png': { uri: '/images/x5c42W9QotvTNKmJyXjzkU.png' },
'hASk6mSxf9FPn6fcxef6oD.png': { uri: '/images/hASk6mSxf9FPn6fcxef6oD.png' },
'2nAXrKsz58Y2kd9Bem9LdP.png': { uri: '/images/2nAXrKsz58Y2kd9Bem9LdP.png' },
'7pz8s6V5vpGdUzZUiMJk21.png': { uri: '/images/7pz8s6V5vpGdUzZUiMJk21.png' },
'sBuWDMxjsxXdibDejR8YVX.png': { uri: '/images/sBuWDMxjsxXdibDejR8YVX.png' },
'bxAjhcZ43LzuSx56gwDX4m.png': { uri: '/images/bxAjhcZ43LzuSx56gwDX4m.png' },
'dv62QHmtuThFvKx2Lc6efa.png': { uri: '/images/dv62QHmtuThFvKx2Lc6efa.png' },
'8M5PBu3xsKjWx3CZfp2ho2.png': { uri: '/images/8M5PBu3xsKjWx3CZfp2ho2.png' },
'xcRYdxvkHJwAFNgvbhKELT.png': { uri: '/images/xcRYdxvkHJwAFNgvbhKELT.png' },
'6nPT8HctXMW1XsRVuoH8Tn.png': { uri: '/images/6nPT8HctXMW1XsRVuoH8Tn.png' },
'6TZodzzYEim7W8kT3ZNViD.png': { uri: '/images/6TZodzzYEim7W8kT3ZNViD.png' },
'vk4o66XRcipnqCoPW5VTbk.png': { uri: '/images/vk4o66XRcipnqCoPW5VTbk.png' },
'6EFeDKCiPZRjxL6VsY3KNC.png': { uri: '/images/6EFeDKCiPZRjxL6VsY3KNC.png' },
'mCeJ4SvCMd3sPaeh4mdQ2o.png': { uri: '/images/mCeJ4SvCMd3sPaeh4mdQ2o.png' },
'1iqKGcmHosufexfWiYyhTr.png': { uri: '/images/1iqKGcmHosufexfWiYyhTr.png' },
'iiNo82nB5ayVTPYQD1qx48.png': { uri: '/images/iiNo82nB5ayVTPYQD1qx48.png' },
'98vCh6kjSU94nD6r2tcr7z.png': { uri: '/images/98vCh6kjSU94nD6r2tcr7z.png' },
'vaDtsCy68xRgL71oCPdpDf.png': { uri: '/images/vaDtsCy68xRgL71oCPdpDf.png' },
'hgmaGwwZXTPQ8bh25nTkCG.png': { uri: '/images/hgmaGwwZXTPQ8bh25nTkCG.png' },
'6Xmm8Goso79CxjNgNKC5CV.png': { uri: '/images/6Xmm8Goso79CxjNgNKC5CV.png' },
'5n9FNvNQwQirBx7EZy5egv.png': { uri: '/images/5n9FNvNQwQirBx7EZy5egv.png' },
'oxwFfmRsLwMm2b4paG6aCp.png': { uri: '/images/oxwFfmRsLwMm2b4paG6aCp.png' },
'nyAKhsmJVhhkD8XevNfD3e.jpg': { uri: '/images/nyAKhsmJVhhkD8XevNfD3e.jpg' },
'hAKYhm3hYSMxdT5goviUVy.png': { uri: '/images/hAKYhm3hYSMxdT5goviUVy.png' },
'jxweCWESDhh2jZUGmyDQ1D.png': { uri: '/images/jxweCWESDhh2jZUGmyDQ1D.png' },
'eqwyCrJsxYAVJAkZ3SFpyu.png': { uri: '/images/eqwyCrJsxYAVJAkZ3SFpyu.png' },
'9MAuLdngK3M9dDXfi1qDCt.png': { uri: '/images/9MAuLdngK3M9dDXfi1qDCt.png' },
'onAS6q2CgLE1466VheHf3a.png': { uri: '/images/onAS6q2CgLE1466VheHf3a.png' },
'2pnAx5jGvdiD5hovikDNTz.png': { uri: '/images/2pnAx5jGvdiD5hovikDNTz.png' },
'ntAcYsD9n9ZPaRV67N5z2H.png': { uri: '/images/ntAcYsD9n9ZPaRV67N5z2H.png' },
'jU2KxHWrzK1KqUBxZeRyUz.png': { uri: '/images/jU2KxHWrzK1KqUBxZeRyUz.png' },
'6m43hDqcKkhbB2eYTxdnw1.png': { uri: '/images/6m43hDqcKkhbB2eYTxdnw1.png' },
'1RCFa9RYosMPTpbi8d25HQ.png': { uri: '/images/1RCFa9RYosMPTpbi8d25HQ.png' },
'f4kDRgjoLmqNMLVTPyH9Y3.png': { uri: '/images/f4kDRgjoLmqNMLVTPyH9Y3.png' },
'eX1YEPPxCNd1xnEuaKmpDs.jpg': { uri: '/images/eX1YEPPxCNd1xnEuaKmpDs.jpg' },
'nBRtTceSmwaLhLaUpzTz2m.png': { uri: '/images/nBRtTceSmwaLhLaUpzTz2m.png' },
'3S3zrDYPAstrEVCHcXt9So.png': { uri: '/images/3S3zrDYPAstrEVCHcXt9So.png' },
'2ea6B7ZuKV6cQfBZ2nTpRj.png': { uri: '/images/2ea6B7ZuKV6cQfBZ2nTpRj.png' },
'pjLx7GewyFZ5TvZQuCJ9X8.png': { uri: '/images/pjLx7GewyFZ5TvZQuCJ9X8.png' },
'kdU4GSGAZtW5dWab3Aknds.jpg': { uri: '/images/kdU4GSGAZtW5dWab3Aknds.jpg' },
'vm1zwbUwYwytLtw6Fsbsvr.jpg': { uri: '/images/vm1zwbUwYwytLtw6Fsbsvr.jpg' },
'jReR15eYJCt9zhcnEZdMoQ.png': { uri: '/images/jReR15eYJCt9zhcnEZdMoQ.png' },
'w9v91NY1tRhABXkKhvFUjk.jpg': { uri: '/images/w9v91NY1tRhABXkKhvFUjk.jpg' },
'xsvaKwqzVffnZPpeK814Ti.jpg': { uri: '/images/xsvaKwqzVffnZPpeK814Ti.jpg' },
'riJeqMWhurDLK3kepDuLWd.png': { uri: '/images/riJeqMWhurDLK3kepDuLWd.png' },
'kP4Jz6nDeeC2Jc7C6Zjr4r.png': { uri: '/images/kP4Jz6nDeeC2Jc7C6Zjr4r.png' },
'6MZQy4eRrP8t1wQTwxmny3.png': { uri: '/images/6MZQy4eRrP8t1wQTwxmny3.png' },
'phxKNhYbKzoLtJK4DYHGL5.png': { uri: '/images/phxKNhYbKzoLtJK4DYHGL5.png' },
'iLREaNUM8eKctxUshVPoLP.png': { uri: '/images/iLREaNUM8eKctxUshVPoLP.png' },
'azFBbyki1qcg7L4VHm64De.png': { uri: '/images/azFBbyki1qcg7L4VHm64De.png' },
'cQE2g67S6iCS6HkxApYCuQ.png': { uri: '/images/cQE2g67S6iCS6HkxApYCuQ.png' },
'nYxicV5VTH577W1YoGYwpg.png': { uri: '/images/nYxicV5VTH577W1YoGYwpg.png' },
'xxp1sjZeRxpc9zdEZ4QtMC.png': { uri: '/images/xxp1sjZeRxpc9zdEZ4QtMC.png' },
'fVdSjJKaAcXuYGW4chZ75H.png': { uri: '/images/fVdSjJKaAcXuYGW4chZ75H.png' },
'tPUqpRoEnPtbkxrv94QLiE.png': { uri: '/images/tPUqpRoEnPtbkxrv94QLiE.png' }
}

export default imageStaticSourcesByFileName
